import React, { useCallback, useEffect, useState } from 'react'
import { ancemntSaveData, ancemntGetData, initAncemntState } from '../../redux/slices/announcementSlice'
import { getAnnouncementTypesPath, deleteAnnouncementTypePath } from '../../services/config'
import { useDispatch, useSelector } from 'react-redux'
import { RiDeleteBinLine } from "react-icons/ri"
import { PiPencilSimpleLineBold } from "react-icons/pi"
import { MdOutlineCategory } from "react-icons/md"

const AnnouncementType = ({
  announcementType, handleAnnouncementTitleId, setAnnouncementType,
  setAnnouncementTypeIcon, handleAnnTypeClicked, setIsEditAnnType,
  setCreateAnnType, handleEditAnnouncementType, isEditAnnTypeSuccess, setIsEditAnnTypeSuccess
}) => {
  const user = JSON.parse(localStorage.getItem("user_data")) || {}
  const dispatch = useDispatch()
  const annStore = useSelector((state) => state.announce)
  const [annTypeLict, setAnnTypeLict] = useState([])
  const [hoveredId, setHoveredId] = useState(null)

  const getAnnTypeList = () => {
    dispatch(ancemntGetData(`${getAnnouncementTypesPath}${user.user_id}`))
  }

  useEffect(() => { getAnnTypeList() }, [])

  useEffect(() => {
    if (annStore.ancemntGetSuccess) {
      setAnnTypeLict(annStore.ancemntGetData)
      dispatch(initAncemntState())
    }
    if (annStore.ancemntSuccess) {
      getAnnTypeList()
      dispatch(initAncemntState())
    }
    if (isEditAnnTypeSuccess === true) {
      setAnnTypeLict([])
      getAnnTypeList()
      setIsEditAnnTypeSuccess(false)
    }
  }, [annStore, isEditAnnTypeSuccess])

  const deleteAnnouncement = (id) => {
    dispatch(ancemntSaveData({
      path: deleteAnnouncementTypePath,
      data: { userId: user.user_id, announceId: id }
    }))
  }

  const editAnnouncement = (data) => {
    handleEditAnnouncementType(data)
    setIsEditAnnType(true)
    setCreateAnnType(true)
  }

  return (
    <div>
      {/* Section header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '6px' }}>
        <div style={{
          width: 32, height: 32, borderRadius: '8px',
          background: 'linear-gradient(135deg,#8660F8,#c4b5fd)',
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <MdOutlineCategory style={{ color: '#fff', fontSize: 16 }} />
        </div>
        <div>
          <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: 'var(--primary-text-color)' }}>
            Select Announcement Type
          </h3>
          <p style={{ margin: 0, fontSize: '12px', color: 'var(--secondary-text-color)' }}>
            Choose the type of announcement you want to create
          </p>
        </div>
      </div>

      {/* Type cards grid */}
      <div style={{
        display: 'flex', flexWrap: 'wrap', gap: '14px',
        marginTop: '16px'
      }}>
        {annTypeLict?.map((item) => {
          const isSelected = announcementType === item.announceId
          const isHovered = hoveredId === item.announceId
          const color = item.colorCode || '#8660F8'

          return (
            <div
              key={item.announceId}
              onClick={() => {
                setAnnouncementType(item.announceId)
                handleAnnouncementTitleId(item.announcementTitleId)
                setAnnouncementTypeIcon(item.announceIcon)
                handleAnnTypeClicked(item)
              }}
              onMouseEnter={() => setHoveredId(item.announceId)}
              onMouseLeave={() => setHoveredId(null)}
              style={{
                position: 'relative',
                width: 'calc(20% - 12px)',
                minWidth: '160px',
                padding: '18px 14px',
                borderRadius: '14px',
                background: isSelected
                  ? `linear-gradient(135deg, ${color}25 0%, ${color}10 100%)`
                  : `linear-gradient(135deg, ${color}10 0%, ${color}05 100%)`,
                border: isSelected
                  ? `1.5px solid ${color}`
                  : isHovered
                    ? `1.5px solid ${color}80`
                    : `1px solid ${color}30`,
                cursor: 'pointer',
                display: 'flex', flexDirection: 'column',
                alignItems: 'center', justifyContent: 'center',
                gap: '10px', overflow: 'hidden',
                transition: 'all 0.2s ease',
                transform: isHovered || isSelected ? 'translateY(-2px)' : 'translateY(0)',
                boxShadow: isSelected
                  ? `0 8px 24px ${color}30`
                  : isHovered
                    ? `0 4px 16px ${color}20`
                    : '0 2px 8px rgba(0,0,0,0.1)',
              }}
            >
              {/* Selected indicator */}
              {isSelected && (
                <div style={{
                  position: 'absolute', top: 8, right: 8,
                  width: 18, height: 18, borderRadius: '50%',
                  background: color,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '10px', color: '#fff', fontWeight: 700
                }}>✓</div>
              )}

              {/* Action buttons — appear on hover */}
              <div style={{
                position: 'absolute', top: 6, left: 6,
                display: 'flex', gap: '4px',
                opacity: isHovered ? 1 : 0,
                transition: 'opacity 0.2s ease'
              }}>
                <button
                  onClick={(e) => { e.stopPropagation(); deleteAnnouncement(item.announceId) }}
                  style={{
                    width: 24, height: 24, borderRadius: '6px',
                    background: '#EF444420', border: '1px solid #EF444440',
                    color: '#F87171', cursor: 'pointer',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '12px'
                  }}
                >
                  <RiDeleteBinLine />
                </button>
                <button
                  onClick={(e) => { e.stopPropagation(); editAnnouncement(item) }}
                  style={{
                    width: 24, height: 24, borderRadius: '6px',
                    background: '#8660F820', border: '1px solid #8660F840',
                    color: '#c4b5fd', cursor: 'pointer',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '12px'
                  }}
                >
                  <PiPencilSimpleLineBold />
                </button>
              </div>

              {/* Glow bg */}
              <div style={{
                position: 'absolute', bottom: -20, right: -20,
                width: 70, height: 70, borderRadius: '50%',
                background: color, opacity: 0.06, filter: 'blur(16px)'
              }} />

              {/* Icon */}
              <div style={{
                width: 52, height: 52, borderRadius: '12px',
                background: `${color}20`,
                border: `1px solid ${color}40`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                {item.announceIcon
                  ? <img src={item.announceIcon} style={{ width: 30, height: 30, objectFit: 'contain' }} />
                  : <span style={{ fontSize: '24px' }}>📢</span>
                }
              </div>

              {/* Text */}
              <div style={{ textAlign: 'center' }}>
                <h3 style={{
                  margin: 0, fontSize: '13px', fontWeight: 600,
                  color: isSelected ? color : 'var(--primary-text-color)',
                  transition: 'color 0.2s'
                }}>
                  {item.announceTypeName}
                </h3>
                <p style={{
                  margin: '4px 0 0', fontSize: '11px',
                  color: 'var(--secondary-text-color)', lineHeight: 1.4
                }}>
                  {item.announceDesc}
                </p>
              </div>

              {/* Bottom accent bar */}
              <div style={{
                position: 'absolute', bottom: 0, left: 0, right: 0,
                height: '3px',
                background: isSelected ? color : 'transparent',
                borderRadius: '0 0 14px 14px',
                transition: 'background 0.2s'
              }} />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default AnnouncementType
